import { createSelector } from "reselect"
import { get, chain } from "lodash"
import { safeDivide } from "helpers/math"
import { getMustAggregateFactors, getStyleExposureAggregation } from "modules/portfolio-root/selectors/portfolios"
import { getModelFactorsClassification } from "selectors/modelMetadata"
import { aggregateExposuresFactors } from "helpers/factorClassification"
import { getMarketValues } from "./positions"

const getRawExposures = state => get(state, "global.data.portfolioExposure.data.model.simulation.exposure.0.factors")

const computeAggregation = (rawExposures, type, marketValues, mustAggregateFactors, styleAggregation, factorsClassification) => {
  const marketValue = get(marketValues, type)
  let display = marketValue
  if (type === "net") {
    display = get(marketValues, "short") && get(marketValues, "long")
  }

  if (!display) {
    return null
  }

  let factors = rawExposures
  if (mustAggregateFactors) {
    factors = aggregateExposuresFactors(factorsClassification, factors, styleAggregation, type)
  }

  return {
    type: "aggregation",
    key: type,
    aggregationType: type,
    size: marketValue,
    percEquity: safeDivide(marketValue, get(marketValues, "equity")),
    factors: chain(factors)
      .map(item => ([item.id, item[type]]))
      .fromPairs()
      .value(),
  }
}

export const getLongAggregation = createSelector(
  [getRawExposures, getMarketValues, getMustAggregateFactors, getStyleExposureAggregation, getModelFactorsClassification],
  (rawExposures, marketValues, mustAggregateFactors, styleAggregation, factorsClassification) => computeAggregation(rawExposures, "long", marketValues, mustAggregateFactors, styleAggregation, factorsClassification),
)

export const getShortAggregation = createSelector(
  [getRawExposures, getMarketValues, getMustAggregateFactors, getStyleExposureAggregation, getModelFactorsClassification],
  (rawExposures, marketValues, mustAggregateFactors, styleAggregation, factorsClassification) => computeAggregation(rawExposures, "short", marketValues, mustAggregateFactors, styleAggregation, factorsClassification),
)

export const getNetAggregation = createSelector(
  [getRawExposures, getMarketValues, getMustAggregateFactors, getStyleExposureAggregation, getModelFactorsClassification],
  (rawExposures, marketValues, mustAggregateFactors, styleAggregation, factorsClassification) => computeAggregation(rawExposures, "net", marketValues, mustAggregateFactors, styleAggregation, factorsClassification),
)
